import { render } from "./instructor-plans-modal.vue?vue&type=template&id=5be4e740"
import script from "./instructor-plans-modal.vue?vue&type=script&lang=js"
export * from "./instructor-plans-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__